//Third party libraries

import NumericMetricWidget from '@/components/Widgets/NumericMetricWidget';
import { kFormatterWithAbbreviation } from '@/utils';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
import type { DashboardType } from '../../../types/Analytics';
//Assets and miscellaneous
import { Widget } from '../constants';
import { type IProjectBySourcesResponse, sourceLimits } from '../FundsLeftWidget';
//Custom components
import WidgetLayout from '../WidgetLayout';

const CityInvestmentWidget = ({ dashboard }: { dashboard: DashboardType }) => {
  const fetchProjectsBySourcesWidgetData = useDashboardData({
    dashboard,
    widget: Widget.PROJECTS_BY_SOURCES,
  });

  const totalCityInvestment = fetchProjectsBySourcesWidgetData?.data?.data
    ?.filter((source: IProjectBySourcesResponse) => Object.hasOwn(sourceLimits, source.source_name))
    .reduce((acc: number, next: IProjectBySourcesResponse) => {
      return acc + next.total_amount;
    }, 0);

  const formattedValue = kFormatterWithAbbreviation(String(totalCityInvestment));

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.PROJECTS_BY_SOURCES} actionsBtnLocation='top-2 right-0'>
      <NumericMetricWidget
        title='City Investment'
        value={formattedValue.value ? formattedValue.value : '0'}
        prefix='$'
        suffix={formattedValue.abbreviation ? formattedValue.abbreviation : ''}
      />
    </WidgetLayout>
  );
};

export default CityInvestmentWidget;
